export function embedOverlay() {
	const videoContainers = document.querySelectorAll('.farlo-ui-video');

	videoContainers.forEach((videoContainer) => {
		const overlay = videoContainer.querySelector('.farlo-ui-video__overlay');
		const iframe = videoContainer.querySelector('.farlo-ui-video__iframe');

		overlay.onclick = function() {
			overlay.style.display = 'none';
			if (iframe && iframe.dataset.src) {
				iframe.src = iframe.dataset.src + '&autoplay=1';
				iframe.style.display = 'block';
			}
		};
	});
}
